const HEADING_OPEN = /<h([1-6])(?=[\s>/])/gi
const HEADING_TAG = /<(\/?)h([1-6])(?=[\s>/])/gi

/**
 * Renumbers the headings of editor content so they follow the page's own `h1` without
 * skipped levels: the levels used in the text are mapped, in order, onto `h2`, `h3`…
 * (`h3, h5` → `h2, h3`; an `h1` in the text becomes `h2`). Only the tag level changes —
 * text, attributes and order stay as written, and content already starting at `h2`
 * without gaps is returned untouched (#1018).
 */
export function normalizeContentHeadings(html: string, topLevel = 2): string {
  const levels = [...new Set([...html.matchAll(HEADING_OPEN)].map((match) => Number(match[1])))].sort(
    (a, b) => a - b
  )

  const target = new Map(levels.map((level, index) => [level, Math.min(topLevel + index, 6)]))

  if ([...target].every(([level, mapped]) => level === mapped)) return html

  return html.replace(
    HEADING_TAG,
    (_, slash: string, level: string) => `<${slash}h${target.get(Number(level)) ?? level}`
  )
}
